var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../../elements/Basic");

var _Standard = require("../../../Standard");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Commentary/Events/Player.js";

var Player = function Player(_ref) {
  var props = (0, _extends2.default)({}, _ref);
  return _react.default.createElement(_Basic.Row, {
    mt: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, _react.default.createElement(_Standard.Player, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 9
    }
  })));
};

Player.propTypes = {
  nickName: _propTypes.default.string.isRequired,
  firstName: _propTypes.default.string.isRequired,
  lastName: _propTypes.default.string.isRequired,
  imageUrl: _propTypes.default.string.isRequired,
  team: _propTypes.default.object.isRequired,
  nationality: _propTypes.default.object.isRequired
};
var _default = Player;
exports.default = _default;